import { CustomerClassification } from '@shared/models/subscription-offering.model';
import { Price, PriceInformation } from '@shared/models/price.model';

export class MobilePhoneSearchItem {
  offeringId?: string;
  gtin?: string;
  colorVariants?: ColorVariant[];
}

export class HardwareInsuranceOption {
  offeringId: string;
  name: string;
  customerClassification: CustomerClassification;
  labels: string[];
  priceInformation: PriceInformation;
}

export class PaymentInformation {
  subscriptionBundleOptions: SubscriptionBundleOption[];
}

export class DefaultPaymentInformation {
  defaultSubscriptionBundleOption: SubscriptionBundleOption;
}

export class PaymentOption {
  id: string;
  type: string;
  name: string;
  priceInformation: PriceInformation;
}

export enum PaymentOptionType {
  Unknown = 'Unknown',
  EquipmentUpgrade = 'EquipmentUpgrade',
  SubscriptionBundle = 'SubscriptionBundle',
}

export class SubscriptionBundleOption {
  id: string;
  name: string;
  priceInformation: PriceInformation;
  offeringId: string;
  subscriptionOfferingId: string;
  subsidyId: string;
  subscriptionName: string;
  subscriptionShortName: string;
  subscriptionHasBinding: boolean;
  subscriptionBindingPeriod: number;
  subscriptionPriceInformation: PriceInformation;
  minimumTotalPrice: Price;
  type: PaymentOptionType;
}

export class ColorVariant {
  offeringId: string;
  value: Color;
}
export class MemoryVariant {
  offeringId: string;
  value: string;
}

export class Image {
  constructor() {}

  id?: string;
  downloadUri?: string;
  previewUri?: string;
  name?: string;
  description?: string;
  fileName?: string;
  contentType?: string;
  labels?: string[];
}

export class Color {
  name: string;
  hex: string;
}
